module.exports = __webpack_public_path__ + "img/fig39.b45ea4dc.jpg";